import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { ConnectionErrorService } from '../connection-error-service/connection-error.service';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: unknown): void {
    console.error('[Global Error]', error);

    try {
      const connectionErrorService = this.injector.get(ConnectionErrorService);
      if (connectionErrorService.isConnectionFailure(error)) {
        connectionErrorService.navigateToErrorPage(error);
      }
    } catch (handlerError) {
      console.error('[Global Error] Failed to classify application error', handlerError);
    }
  }
}
